import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { coerceHttpParams } from 'src/app/shared/flight-log-api/shared/create-request-options';
import { AppState } from 'src/store';
import { DeleteFbo, UpsertFbo, UpsertFbos } from 'src/store/fbo/fbo.actions';
import { FboEntity } from 'src/store/fbo/fbo.model';
import { assertNotNullOrWhitespace } from 'src/util/values';
import { FLIGHT_LOG_API_CONFIG, FlightLogApiConfiguration } from '../flight-log-api-configuration';

@Injectable({
  providedIn: 'root',
})
export class FboHttpClient {
  constructor(
    @Inject(FLIGHT_LOG_API_CONFIG) private config: FlightLogApiConfiguration,
    private http: HttpClient,
    private _store: Store<AppState>,
  ) {}

  public getById(fboId: string): Observable<FboEntity | undefined> {
    assertNotNullOrWhitespace(fboId, 'fboId');
    return this.http.get<FboEntity | undefined>(this.url(`fbos/${fboId}`)).pipe(
      tap((fbo) => {
        this._store.dispatch(fbo != null ? new UpsertFbo({ fbo }) : new DeleteFbo({ id: fboId }));
      }),
    );
  }

  public getAll(params: { $top?: number; searchTerm?: string } = {}): Observable<FboEntity[]> {
    return this.http
      .get<FboEntity[]>(this.url('fbos'), {
        params: coerceHttpParams({
          $top: 100,
          ...params,
        }),
      })
      .pipe(tap((fbos) => this._store.dispatch(new UpsertFbos({ fbos }))));
  }

  public url(path: string) {
    return this.config.baseUri + '/api/' + path;
  }
}
